<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 18:15:08
 * @LastEditTime: 2019-09-20 13:35:16
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div id="page_Container">
    <div class="page">
        <div id="main-container" class="main-container">
            <div class="couponsrules">
                <div class="title">优惠券规则</div>
                <div class="contain">
                    <p>1，一次下单只能使用一张优惠券</p>
                    <p>2，支持优惠券的商品，若满减条件相同（如满199元减20元）且实际付款金额达到满减门槛，可共用一张优惠券</p>
                    <p>3，运费，税金等不计入满减门槛</p>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
import { toastLoading, clearToastLoading } from '@/utils/base/utils';

export default {
    name: 'platform',
    data () {
        return {

        };
    },
    esvReady: function() {
        document.title = '优惠券规则';
        const ths = this;
        ths.init();
    },
    esvShow: function() {
        this.ESVStorage.putSavedValue('cTabIndex', 1);
    },
    methods: {
        // 初始化
        init() {
            const ths = this;
            ths.ploading = !ths.isLoading;
            ths.$doRequest(
                {
                    url: '/mobile/category/queryCategoryListByMerchantCode',
                    params: {

                    },
                    before: function() {
                        ths.loading = toastLoading();
                    },
                    complete: function() {
                        ths.isLoading = false;
                        clearToastLoading(ths.loading);
                    }
                },
                function(data) {
                    ths.items = data.result.normal;
                    ths.especially = data.result.especially;
                    let current;
                    this.ESVStorage.getSavedValue('current', (data) => {
                        current = data;
                    });
                    if (current) {
                        ths.current = current;
                    }
                }
            );
        },
        addclass(index) {
            this.ESVStorage.putSavedValue('current', index);
            this.current = index;
        },
        golist: function(item) {
            this.ESVStorage.putSavedValue('id', item.id);
            this.esvOpenPage({ name: 'OPGoodlist', params: { id: item.id, merchantCode: item.merchantCode } });
        },
        onClickLeft () {
            this.$toast.success('左按钮被点击');
        },
        onClickRight () {
            this.$toast.fail('右按钮被点击');
        }
    }
};
</script>
<style lang="scss" scoped>
    .couponsrules{
        .title{
            height: 80px;
            line-height: 80px;
            text-align: center;
            background-color: #EE2E50;
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #FFF;
        }
        .contain{
            background-color: #fff;
            height: 290px;
            font-size: 14px;
            color: #414141;
            p{
                height: 80px;
                border-bottom: 1px solid #E3E2E2;
                padding: 0 15px;
                display: flex;
                align-items: center;
            }
        }
    }
</style>
